import TalentEngineHiring from 'components/marketingSite/talentEngineV3/pages/TalentEngineHiring';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { WithBaseUrl } from 'interfaces/ui/with-base-url';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { APP_URLS } from 'utils/app-urls';
import { config } from 'utils/config';
import { getPublicPath } from 'utils/paths';

type TalentEngineHiringProps = WithBaseUrl;

const TalentEngineHiringPage: React.FC<TalentEngineHiringProps> = ({
  baseUrl
}) => {
  const { t } = useI18n('talent-engine-hiring');

  usePageTrack('Landing - Page Loaded');

  return (
    <>
      <HeadMetadata
        title={t('talent-engine-hiring.page_title')}
        url={APP_URLS.talentEngineHiring}
        desc={t('talent-engine-hiring.page_description')}
        imgUrl={`${baseUrl}${getPublicPath(
          '/images/cards/card_talent_engine.png'
        )}`}
        indexable={true}
      />
      <TalentEngineHiring />
    </>
  );
};

export default TalentEngineHiringPage;

export const getStaticProps: GetStaticProps<TalentEngineHiringProps> = async ({
  locale
}) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'talent-engine-hiring',
        'talent-engine-landing-v3'
      ])),
      baseUrl: config.appUrl
    },
    revalidate: 30
  };
};
